import { render, staticRenderFns } from "./PostsList.vue?vue&type=template&id=0c9abd5f&scoped=true"
import script from "./PostsList.vue?vue&type=script&lang=js"
export * from "./PostsList.vue?vue&type=script&lang=js"
import style0 from "./PostsList.vue?vue&type=style&index=0&id=0c9abd5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9abd5f",
  null
  
)

export default component.exports